module.exports = __webpack_public_path__ + "static/dashboard_SponsorshipM@2x-ac26207f504b267b7355908b7a208677.jpg";